/* XINNERG core JS. Vanilla. Fills WhatsApp links, month tokens, mobile nav, tap states. */
(function () {
  function waNumber() {
    var g = document.getElementById('xin-g');
    return g ? (g.getAttribute('data-wa') || '').replace(/\D/g, '') : '';
  }

  function init(root) {
    var scope = root || document;
    var n = waNumber();
    scope.querySelectorAll('[data-xin-wa]').forEach(function (a) {
      a.setAttribute('href', 'https://wa.me/' + n + '?text=' + a.getAttribute('data-xin-wa'));
    });
    var lang = document.documentElement.lang || 'en';
    var month;
    try { month = new Date().toLocaleString(lang, { month: 'long' }); } catch (e) { month = null; }
    if (month) {
      scope.querySelectorAll('[data-xin-month]').forEach(function (el) { el.textContent = month; });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-xin-nav]');
    if (!btn) return;
    var root = btn.closest('[data-xin-header]');
    if (!root) return;
    var open = root.getAttribute('data-open') === 'true';
    root.setAttribute('data-open', open ? 'false' : 'true');
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-xin-thumb]');
    if (!t) return;
    var g = t.closest('[data-xin-gallery]');
    var m = g && g.querySelector('[data-xin-main]');
    if (!m) return;
    m.setAttribute('src', t.getAttribute('data-full'));
    m.setAttribute('alt', t.getAttribute('data-alt') || '');
    g.querySelectorAll('[data-xin-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
    t.setAttribute('aria-current', 'true');
  });

  /* iOS Safari needs a touch listener before :active applies */
  document.addEventListener('touchstart', function () {}, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
